export default "__VITE_ASSET__82a34362__"